import angular from 'angular';

angular.module('prepaid', ['application']);

angular.module('prepaid').config(["$translatePartialLoaderProvider", function($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('prepaid');
    /* Add New States Above */
}]);
